/**
 * P3: masking for the screenshot. Runs on snapdom's CLONE of the page
 * (afterClone), never on the live DOM, so the customer never sees a flicker
 * and nothing can be left masked behind.
 *
 * Readable: the chrome -- buttons, labels, table heads, headings, and any leaf
 * marked data-meld-toon (a fixed i18n text; meldToonRegel.ts enforces that).
 * Always masked: data-meld-geheim (tenant and user names), even with toon.
 */
export const LEESBAAR = 'button, label, th, h1, h2, h3, [data-meld-toon]';
export const GEHEIM = '[data-meld-geheim]';

const PUNT = '•';

function metPunten(s: string): string {
  return s.replace(/\S/g, PUNT);
}

export function maskeer(root: Element, o: { toon: boolean }): void {
  const walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const teksten: Text[] = [];
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    if (n instanceof Text) teksten.push(n);
  }
  for (const t of teksten) {
    const ouder = t.parentElement;
    if (!ouder || !t.data.trim()) continue;
    const geheim = ouder.closest(GEHEIM) !== null;
    const leesbaar = ouder.closest(LEESBAAR) !== null;
    if (geheim || (!o.toon && !leesbaar)) t.data = metPunten(t.data);
  }
  for (const veld of Array.from(root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea'))) {
    if (!o.toon || veld.closest(GEHEIM) !== null) {
      const gemaskeerd = metPunten(veld.value);
      veld.value = gemaskeerd;
      veld.setAttribute('value', gemaskeerd);
    }
  }
}
